jQuery.extend(jQuery.expr[':'], {
	focusable: function (el) {
		return $(el).not("[disabled], [tabindex='-1']").is("[contentEditable=true], [tabindex], a[href], area[href], button, iframe, input, select, textarea");
	}
});


// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.focusable.js